export class BlogCreateController {

    constructor($scope, $rootScope, UserService, BlogService, toastr, $location) {
        $scope.vm = this;
        $scope.newBlogName = "";
        $scope.newBlogDesc = "";
        $scope.newBlogCategory = 0;

        $scope.allCategories = [{
          _id: 0,
          name: "Elige una Categoría",
          selected: "selected"
        }];

        this.scope = $scope;
        this.rootScope = $rootScope;
        this.toastr = toastr;
        this.location = $location;
        this.UserService = UserService;
        this.BlogService = BlogService;

        this.scope.isVip = false;

        this.init();
    }

    init() {
      this.scope.isLoadedPage = false;
      this.scope.isVip = () => this.rootScope.isVip() && this.rootScope.currentUserProfile.usertype === +'4';

      //Get Categories
      this.BlogService.getCategories()
        .then((response) => { let categories = response.data;
          _.forEach(categories.data, (category) => {
            this.scope.allCategories.push(category);
          });
        })
        .catch((response) => { let error = response.data;
          console.log(error);
        });

      this.scope.saveBlog = (name, content, category, form) => {
        if(this.rootScope.isVip() && this.rootScope.currentUserProfile.usertype === +'4') {
          //console.log(url)
          if ((form.$valid) && (form['blogImg'].$modelValue !== 0)){
            var newBlog = {
              user: this.rootScope.currentUserProfile._id,
              title: name,
              content:  content,
              category: category,
              status: false
            };

            this.BlogService.createBlog(newBlog)
              .then((_res) => { let response = _res.data;
                this.toastr.info("Tu blog se encuentra en revisión antes de ser publicado");
                this.location.path('/blogrd');
              })
              .catch((response) => { let error = response.data;
                console.log(error);
              });
          }
          else {
            //console.log(form['blogImg']);
            Object.keys(form).forEach( (key) => {
              switch (key) {
                case 'blogTitle':
                  if(form[key].$invalid){
                    this.toastr.warning("Debes indicar el titulo del blog");
                    break;
                  }
                case 'blogDesc':
                  if(form[key].$invalid){
                    this.toastr.warning("Debes indicar el detalle del blog");
                    break;
                  }
                case 'blogImg':
                  if((form[key].$invalid) || (form[key].$modelValue==0)){
                    this.toastr.warning("Debes indicar la categoria del blog");
                    break;
                  }
                default:
                  break;
              }
            });
          }
        }
      }

      this.UserService.getCurrentUser()
        .then((response) => { let user = response.data;
          this.scope.isLoadedPage = true;
          this.rootScope.currentUserProfile = user.data;
        })
        .catch((response) => { let error = response.data;
          this.scope.isLoadedPage = true;
          console.log(error);
        });
    }
}
